import { apiRequest } from "../../utils/apiUtils";

export const updateApi = {
  getUpdate: () =>
    apiRequest<any>("get", "/app-update/list", { fullResponse: true }),
};
